import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const COLOURS = [
  { name: "Rose Pink", note: "3–6 months", img: "/assets/binky-pack-pink.png" },
  { name: "Classic Blue", note: "3–6 months", img: "/assets/blue-pack.png" },
  { name: "Cherry Red", note: "3–6 months", img: "/assets/binky-pack-red.png" },
  { name: "Sunny Yellow", note: "3–6 months", img: "/assets/binky-pack-yellow.png" },
];

export const Colours = () => (
  <section
    id="colours"
    data-testid="colours-section"
    className="relative overflow-hidden bg-gradient-to-b from-white via-binky-pinklight/50 to-white py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow className="text-binky-pink">Product Colours</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          One design. <span className="text-binky-pink">Colours to love.</span>
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 md:text-lg">
          The genuine Mi Binky range — pink, blue, red and yellow — with every colour sharing the
          exact same protected chamber design. Additional colours are planned as the range grows.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-12" data-testid="colours-promo-banner">
        <motion.div
          whileHover={{ scale: 1.01 }}
          transition={{ type: "spring", stiffness: 160, damping: 20 }}
          className="overflow-hidden rounded-[32px] border border-slate-100 bg-white shadow-xl shadow-binky-pink/10"
        >
          <img
            src="/assets/promo-4pack.png"
            alt="The Mi Binky Comfort System range — pink, blue, red and yellow packs"
            loading="lazy"
            className="h-[300px] w-full object-cover object-[50%_28%] sm:h-[380px]"
            data-testid="colours-promo-image"
          />
        </motion.div>
      </Reveal>

      <div className="mt-6 grid grid-cols-2 gap-5 lg:grid-cols-4">
        {COLOURS.map((c, i) => (
          <Reveal
            key={c.name}
            delay={i * 0.08}
            className="group overflow-hidden rounded-[28px] border border-slate-100 bg-white shadow-[0_20px_50px_-24px_rgba(27,79,160,0.25)] transition-all duration-500 hover:-translate-y-1.5"
            data-testid={`colour-card-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="flex h-56 items-center justify-center overflow-hidden bg-gradient-to-b from-slate-50 to-white p-4 sm:h-64">
              <img
                src={c.img}
                alt={`Mi Binky pack — ${c.name}`}
                loading="lazy"
                className="max-h-full w-auto object-contain drop-shadow-lg transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between px-5 py-4">
              <h3 className="font-display text-base font-bold text-slate-900">{c.name}</h3>
              <span className="rounded-full bg-binky-pinklight px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-binky-pink">
                {c.note}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-8">
        <p className="text-sm text-slate-500" data-testid="colours-note">
          Also available: Blush Pink 0–6 months. Further colours are planned as the range grows —
          the pacifier design itself never changes.
        </p>
      </Reveal>
    </div>
  </section>
);
